/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { InstanceService } from '@commonspirit/ngx-instance';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';

@Component({
  selector: 'fal-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent {
  @Input() htmlSideNavigationContent: string;
  private vmfhBaseUrl: string;

  constructor(public instanceService: InstanceService, private el: ElementRef) {}

  @HostListener('window:click', ['$event'])
  handleClick(event: Event) {
    if ((event.target as Element).className.trim() === 'accordion-title') {
      (event.target as Element).className = 'accordion-title active';
      ((event.target as Element).nextSibling?.nextSibling as Element).className = 'panel active';
      ((event.target as Element).parentElement as Element).className = 'nav-li-bg';
    } else if ((event.target as Element).className === 'accordion-title active') {
      (event.target as Element).className = 'accordion-title ';
      ((event.target as Element).nextSibling?.nextSibling as Element).className = 'panel ';
      ((event.target as Element).parentElement as Element).className = '';
    } else if ((event.target as Element).tagName.toUpperCase() === 'A') {
      if (!location.hostname?.includes('vmfh')) {
        event.preventDefault();
        const nav = (event.target as Element).outerHTML;
        const div = document.createElement('div');
        div.innerHTML = nav;
        const navLink = div.querySelector('a')?.href;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const origin = new URL(navLink!).origin;
        const vmfhUrl = this.instanceService.getConfiguration(ConfigurationKey.VmfhBaseUrl)?.value as { link: string };
        this.vmfhBaseUrl = `${vmfhUrl.link}`;
        if (window.location.origin.toLocaleLowerCase().includes('http://localhost')) this.vmfhBaseUrl = 'https://vmfhorg.cshcontentdev.org';
        const navigateTo = navLink?.replace(origin, this.vmfhBaseUrl);
        window.open(navigateTo, '_blank');
      }
    }
  }
}
